import { z } from 'zod';

export const documentListItemSchema = z.object({
  id: z.string(),
  name: z.string(),
  content_type: z.string(),
});

export type DocumentListItem = z.infer<typeof documentListItemSchema>;

export const documentListResponseSchema = z.object({
  items: z.array(documentListItemSchema),
  total: z.number().optional(),
});

export type DocumentListResponse = z.infer<typeof documentListResponseSchema>;
export type DocumentListResponseApi = z.input<typeof documentListResponseSchema>;
